/* Stykhia paid add-on (snippets/sm-addon.liquid, cart rows in snippets/sm-cart-addon.liquid).
   Product page: the product form and its submit are untouched. When Dawn's product-form.js has added the
   portrait (cartUpdate event from 'product-form', also after the sticky bar's .click() on the main button)
   and the switch is on, the add-on is added as its own line, qty 1, with "For" (style name — variation) and
   "_parent_key" (key of the portrait line). One add-on per portrait line: none is added when that line
   already has one. If it fails, the portrait stays in the cart and a quiet message is shown.
   Cart (drawer, cart page): after a change, add-on lines whose portrait is gone are removed and an add-on
   never has more than qty 1. */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  var PARENT = '_parent_key';

  function isAddon(item) {
    return item && item.properties && item.properties[PARENT];
  }

  function cartJson() {
    return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function postJson(url, body) {
    return fetch(url, Object.assign(fetchConfig(), { body: JSON.stringify(body) })).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Cart error');
        return data;
      });
    });
  }

  /* ---------- product page ---------- */
  var block = document.querySelector('[data-sm-addon]');
  if (block) {
    var toggle = block.querySelector('[data-sm-addon-toggle]');
    var message = block.querySelector('[data-sm-addon-message]');

    function showError() {
      var text = block.dataset.error;
      if (!text) return;
      message.textContent = text;
      message.hidden = false;
      /* also in the drawer, after its own refresh so it is not replaced */
      var drawerItems = document.querySelector('cart-drawer-items');
      var refresh = drawerItems && drawerItems.onCartUpdate ? drawerItems.onCartUpdate() : Promise.resolve();
      Promise.resolve(refresh).then(function () {
        var errors = document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = text;
      });
    }

    function forValue(line) {
      var style = block.dataset.styleName || '';
      var variation = line.properties && line.properties[block.dataset.variationProperty];
      return variation ? style + ' — ' + variation : style;
    }

    function addFor(line) {
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      return cartJson()
        .then(function (state) {
          var has = state.items.some(function (item) {
            return isAddon(item) && item.properties[PARENT] === line.key;
          });
          if (has) return null;

          var properties = {};
          properties[block.dataset.forProperty || 'For'] = forValue(line);
          properties[PARENT] = line.key;
          var body = {
            items: [{ id: Number(block.dataset.variantId), quantity: 1, properties: properties }],
          };
          if (cart) {
            body.sections = cart.getSectionsToRender().map(function (section) {
              return section.id;
            });
            body.sections_url = window.location.pathname;
          }
          return postJson(window.routes.cart_add_url + '.js', body);
        })
        .then(function (response) {
          if (!response) return;
          message.hidden = true;
          if (cart && response.sections) {
            /* the notification shows the portrait line (the add-on is listed inside it) */
            cart.renderContents({ id: line.id, key: line.key, sections: response.sections });
          }
          /* Dawn's drawer refreshes itself on cartUpdate; a refresh started before the add-on existed
             must not be the last one */
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sm-addon', cartData: response });
        })
        .catch(function (error) {
          console.error(error);
          showError();
        });
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form' || !toggle.checked) return;
      var line = event.cartData;
      if (!line || !line.key || isAddon(line)) return;
      if (String(line.product_id) !== block.dataset.productId) return;
      addFor(line);
    });
  }

  /* ---------- cart: no add-on without its portrait, never more than one ---------- */
  function fixes(items) {
    var keys = {};
    items.forEach(function (item) {
      if (!isAddon(item)) keys[item.key] = true;
    });
    var seen = {};
    var updates = {};
    var any = false;
    items.forEach(function (item) {
      if (!isAddon(item)) return;
      var parent = item.properties[PARENT];
      if (!keys[parent] || seen[parent]) {
        updates[item.key] = 0;
        any = true;
      } else {
        seen[parent] = true;
        if (item.quantity > 1) {
          updates[item.key] = 1;
          any = true;
        }
      }
    });
    return any ? updates : null;
  }

  function cartItemsElement() {
    /* the cart page has its own list; elsewhere the drawer */
    return document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  }

  function render(element, sections, state) {
    sections.forEach(function (section) {
      var host = document.getElementById(section.id);
      var html = state.sections && state.sections[section.section];
      if (!host || !html) return;
      var target = host.querySelector(section.selector) || host;
      target.innerHTML = element.getSectionInnerHTML(html, section.selector);
    });
    var empty = state.item_count === 0;
    element.classList.toggle('is-empty', empty);
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', empty);
    var footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-empty', empty);
  }

  var fixing = false;
  function tidy(items) {
    var updates = items && fixes(items);
    if (!updates || fixing) return;
    var element = cartItemsElement();
    var body = { updates: updates };
    var sections = [];
    if (element && element.getSectionsToRender) {
      sections = element.getSectionsToRender();
      body.sections = sections.map(function (section) {
        return section.section;
      });
      body.sections_url = window.location.pathname;
    }
    fixing = true;
    postJson(window.routes.cart_update_url + '.js', body)
      .then(function (state) {
        if (element && sections.length) render(element, sections, state);
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        fixing = false;
      });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (!event || event.source !== 'cart-items') return;
    var data = event.cartData;
    if (data && Array.isArray(data.items)) tidy(data.items);
  });

  /* the cart page also checks once on load (a portrait may have been removed elsewhere) */
  if (document.querySelector('cart-items') && !document.querySelector('cart-items.is-empty')) {
    cartJson()
      .then(function (state) {
        tidy(state.items);
      })
      .catch(function () {});
  }
})();
